// src/api/features/uploads/mutations.ts
import { useMutation } from "@tanstack/react-query";

import { uploadImage } from "./api";
import type { UploadImageBody, UploadImageResult } from "./types";

/**
 * 🔹 Upload a single image via the generic uploads API.
 *
 * - Sends multipart/form-data with a single "file" field.
 * - `module` + `tag` control where the asset is stored (tours, suppliers, users, etc.).
 * - Returns the uploaded asset info (url + key).
 *
 * Usage:
 *   const { mutateAsync: uploadImageMut, isPending } = useUploadImage();
 *
 *   await uploadImageMut({
 *     file,
 *     module: "tours",
 *     tag: "gallery",
 *   });
 */
export function useUploadImage() {
  return useMutation<UploadImageResult, unknown, UploadImageBody>({
    mutationFn: (payload: UploadImageBody) => uploadImage(payload),
  });
}
